import MuiTypography from "@mui/material/Typography";
import { TypographyProps } from "@mui/material/Typography";

const Typography = MuiTypography;

export default Typography;
export type { TypographyProps };
